import { render } from "./PostingRecordDiffRow.vue?vue&type=template&id=47424ee8&scoped=true&ts=true"
import script from "./PostingRecordDiffRow.vue?vue&type=script&lang=ts"
export * from "./PostingRecordDiffRow.vue?vue&type=script&lang=ts"

import "./PostingRecordDiffRow.vue?vue&type=style&index=0&id=47424ee8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47424ee8"]])

export default __exports__